module.exports = __webpack_public_path__ + "static/media/DSCF9439.d8a4c742.jpg";